/* ==========================================================================
   Search synonyms — rewrites Czech and Slovak product terms to the English
   terms stored in Shopify. Keep every alias in exactly one canonical group.

   Accented spellings do not need separate entries: both aliases and customer
   queries are stripped of diacritics for matching.
   ========================================================================== */

(function () {
  'use strict';

  if (typeof window === 'undefined') return;

  window.EssentialsVault = window.EssentialsVault || {};
  if (typeof window.EssentialsVault.normalizeSearchQuery === 'function') return;

  const SEARCH_ALIASES = {
    hoodie: [
      'mikina',
      'mikina s kapuci',
      'mikina s kapucou',
      'mikina s kapucnou',
      'kapucnac',
      'klokanka'
    ],
    'zip hoodie': [
      'mikina na zip',
      'zipova mikina',
      'mikina se zipem',
      'mikina na zips'
    ],
    crewneck: [
      'mikina bez kapuce',
      'mikina bez kapucne',
      'crewneck',
      'mikina crew',
      'klasicka mikina',
      'svetr'
    ],
    sweatpants: [
      'teplaky',
      'teplakove kalhoty',
      'teplakove nohavice',
      'teplaky s kapsami',
      'jogger',
      'joggers'
    ],
    shorts: [
      'kratke nohavice',
      'kratasy',
      'kratase',
      'sortky',
      'kratke kalhoty',
      'kratasky'
    ],
    tee: [
      'tricko',
      'triko',
      'tricka',
      'tee shirt',
      't shirt',
      'tshirt'
    ],
    '1977': [
      '1977'
    ]
  };

  function matchingText(value) {
    return String(value)
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '');
  }

  const aliasToCanonical = {};

  Object.keys(SEARCH_ALIASES).forEach((canonical) => {
    SEARCH_ALIASES[canonical].forEach((alias) => {
      const matchingAlias = matchingText(alias);
      const existingCanonical = aliasToCanonical[matchingAlias];

      if (existingCanonical && existingCanonical !== canonical) {
        throw new Error(`Search alias "${alias}" belongs to multiple canonical groups.`);
      }

      aliasToCanonical[matchingAlias] = canonical;
    });
  });

  Object.keys(SEARCH_ALIASES).forEach((canonical) => {
    const canonicalAsAlias = aliasToCanonical[matchingText(canonical)];
    if (canonicalAsAlias && canonicalAsAlias !== canonical) {
      throw new Error(`Canonical search term "${canonical}" cannot be an alias of "${canonicalAsAlias}".`);
    }
  });

  window.EssentialsVault.normalizeSearchQuery = function (rawQuery) {
    const query = String(rawQuery == null ? '' : rawQuery);
    const trimmedQuery = query.trim();
    if (!trimmedQuery) return query;

    const tokens = trimmedQuery.split(/\s+/);
    const rewrittenTokens = [];
    let matched = false;

    for (let index = 0; index < tokens.length;) {
      let canonical = '';
      let matchedLength = 0;
      const maxPhraseLength = Math.min(3, tokens.length - index);

      for (let phraseLength = maxPhraseLength; phraseLength >= 1; phraseLength -= 1) {
        const phrase = tokens.slice(index, index + phraseLength).join(' ');
        const candidate = aliasToCanonical[matchingText(phrase)];

        if (candidate) {
          canonical = candidate;
          matchedLength = phraseLength;
          break;
        }
      }

      if (canonical) {
        rewrittenTokens.push(canonical);
        index += matchedLength;
        matched = true;
      } else {
        rewrittenTokens.push(tokens[index]);
        index += 1;
      }
    }

    return matched ? rewrittenTokens.join(' ') : query;
  };
})();
